import React, { useEffect, useState, useMemo, useContext } from 'react'
import * as classes from './Management.module.scss'
import Container from '../../../ui/Container/Container'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { FormContext } from '../../../../context'
import splitRow from '../../../../utils/splitRow'
import { startAnimationScroll } from '../../../../utils/animations'

function Management({ data, lang }) {
    const { animationStart } = useContext(FormContext)

    const sectionTitle = useMemo(() => deleteHtmlTag(data.titleSmall.value, 'p'), [])
    const titleFormat = useMemo(() => deleteHtmlTag(data.title.value, 'p'), [])
    const text = useMemo(() => deleteHtmlTag(data.text.value, 'p'), [])
    const experienceTitle = useMemo(() => deleteHtmlTag(data.experienceTitle.value, 'p'), [])

    const [title, setTitle] = useState({
        top: titleFormat,
        experience: experienceTitle
    })

    const classAnimationText = 'anime-text-shareholders'

    useEffect(() => {
        if (animationStart) {
            splitRow(classAnimationText)
        }

        const observer = startAnimationScroll([
            { type: 'text', className: classAnimationText }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    return (
        <section className={classes.Section}>
            {sectionTitle || title.top || text ? (
                <Container>
                    {sectionTitle ? <SectionTitle className={classes.SectionTitle} title={sectionTitle} lang={lang} /> : null}

                    {title || text ? (
                        <div className={classes.Content}>
                            {title.top ? (
                                <h2 className={`${classAnimationText} ${classes.Title}`} dangerouslySetInnerHTML={{ __html: title.top }} />
                            ) : null}

                            {text ? (
                                <div className={`${classAnimationText} ${classes.Text}`}>
                                    <p dangerouslySetInnerHTML={{ __html: text }} />
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </Container>
            ) : null}
        </section>
    )
}

export default Management
